import { asyncImportWrapper } from "@lana-commerce/core/asyncModuleWrapper";
export type UIType = ReturnType<(typeof import("./core_impl"))["load"]>["state"];
export const UI = asyncImportWrapper(() => import("./core_impl"));
